<!--use a s sample to build out new route/child route logic-->
<template>
    <v-content v-if="org">
        <v-card>
            <v-card-title>
                {{org.info.fullname}} Page Data
            </v-card-title>
            <v-container>
                <v-row >
                    <v-col v-for="t in tiles"   :key="t.to">
                        <v-card  :to="t.to" outlined height="70" >
                            <v-card-text>
                                <div class="text-center">
                                    <v-icon>{{icons[t.icon]}}</v-icon>
                                </div>
                                <div class="text-center">{{t.name}}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <router-view></router-view>
    </v-content>
</template>

<script>
  const PATH = '/pagedata' //im lazy and hate writing `"organi....
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        menu: true,
        tiles:[
          {to: PATH+'/', icon: 'share', name: 'PD Home'},
        ],
        activating:false
      }
    },
    computed:{
      ...mapState(['org','icons']),
    },
    mounted() {
    },
    methods: {
      ...mapActions(['get','post','putAppOrg'])
    }
  }
</script>

<style scoped>

</style>